import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-tanhao1",
  "use": "icon-icon-tanhao1-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-tanhao1\"><path d=\"M512 32C247.68 32 32 247.04 32 512s215.68 480 480 480 480-215.04 480-480S776.96 32 512 32z m0 832c-193.92 0-352-158.08-352-352S318.08 160 512 160s352 158.08 352 352-158.08 352-352 352z\" /><path d=\"M508.8 707.2m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z\" /><path d=\"M506.88 599.68c35.2 0 64-28.8 64-64V286.72c0-35.2-28.8-64-64-64s-64 28.8-64 64v248.96c0 35.2 28.8 64 64 64z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-tanhao1.svg
// module id = kyfn
// module chunks = 3